export const UPDATE_SERVER_LIVE_CLOCK =
  "[Server Action] Update Server Live Clock";
